import classNames from 'classnames';
import { forwardRef } from 'react';

import { TourClasses } from '@revelio/core';
import { Button, type PopoverProps } from '@revelio/ui';

import styles from './FilterMenu.module.css';
import { FilterPopover } from './FilterPopover';
import { FILTER_MENU_TRIGGER_TESTID } from './filter-menu-testid';

const FilterFunnelIcon = () => (
  <svg
    width="13"
    height="12"
    viewBox="0 0 11 10"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.0479 0H0L4.01915 4.79085V8.10292L6.02873 9.11579V4.79085L10.0479 0Z"
      fill="currentColor"
    />
  </svg>
);

interface FilterButtonProps {
  isDisabled?: boolean;
}

const FilterButton = forwardRef<HTMLButtonElement, FilterButtonProps>(
  ({ isDisabled, ...props }, ref) => {
    return (
      <Button
        {...props}
        ref={ref}
        variant="link"
        disabled={isDisabled}
        className={styles.filterButton}
        size="sm"
        data-testid={FILTER_MENU_TRIGGER_TESTID}
      >
        <span className={styles.filterButtonLabel}>
          <FilterFunnelIcon />
          <span className={styles.filterButtonText}>Filter</span>
        </span>
      </Button>
    );
  }
);

interface FilterMenuProps {
  isDisabled?: boolean;
  popoverPlacement?: PopoverProps['placement'];
  shiftLeft?: boolean;
}

export const FilterMenu = ({
  isDisabled = false,
  popoverPlacement = 'bottom-start',
  shiftLeft = false,
}: FilterMenuProps) => {
  return (
    <div
      className={classNames(
        styles.filterMenu,
        TourClasses.TOUR_FILTER_MENU_CLASS,
        shiftLeft && styles.shiftLeft
      )}
    >
      <div className={styles.filterMenuRow}>
        <div className={styles.filterMenuTrigger}>
          <FilterPopover
            trigger={<FilterButton isDisabled={isDisabled} />}
            placement={popoverPlacement}
          />
        </div>
      </div>
    </div>
  );
};
